const dataObject = {
  id: 2,
  type: 'Order',
  attributes: {
    number: '1',
    theme: 'string',
    typeofWork: 'string',
    course: 'string',
    status: 'string',
    deadline: 'string',
    originality: {
      percent: 100,
      source: 'Etxt (стандартные настройки)',
    },
    typography: {
      pages: 'string',
      fontSize: 'string',
      interval: 0,
    },
    description: 'string',
  },
};

export { dataObject };
